import { render, staticRenderFns } from "./ApproveCandidate.vue?vue&type=template&id=2375f9c8"
import script from "./ApproveCandidate.vue?vue&type=script&lang=js"
export * from "./ApproveCandidate.vue?vue&type=script&lang=js"
import style0 from "./ApproveCandidate.vue?vue&type=style&index=0&id=2375f9c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports